export const hero = {
  "title": "Intercambia entre anfitriones,",
  "titleHighlight": "en toda Europa",
  "subtitle": "Club de intercambio europeo reservado para anfitriones de Airbnb con calificación 4.5+ con suscripción única para Europa.",
  "cta": "Comenzar el intercambio",
  "learnMore": "Más información",
  "stats": {
    "owners": "Propietarios activos",
    "countries": "Países disponibles",
    "exchanges": "Intercambios realizados"
  },
  "slogans": {
    "slogan1": {
      "title": "Club privado",
      "highlight": "anfitriones Airbnb 4.5+",
      "subtitle": "Acceso reservado a anfitriones bien calificados para intercambiar en un entorno de confianza."
    },
    "slogan2": {
      "title": "Oferta de lanzamiento 2026",
      "highlight": "-50% para los primeros 1000",
      "subtitle": "25EUR/año en lugar de 50EUR/año, con precio garantizado de por vida."
    },
    "slogan3": {
      "title": "Precio garantizado de por vida",
      "highlight": "1000 primeros miembros",
      "subtitle": "Los primeros 1000 inscritos conservan su tarifa de por vida."
    },
    "slogan4": {
      "title": "Sin intermediarios,",
      "highlight": "solo conexión",
      "subtitle": "Una comunidad de confianza donde se intercambian estancias, no noches vendidas."
    },
    "slogan5": {
      "title": "Únete al club",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "El club de intercambio pensado para anfitriones de Airbnb activos en Europa."
    },
    "slogan6": {
      "title": "Temporada baja",
      "highlight": "optimizada",
      "subtitle": "Transforma tus periodos vacíos en oportunidades de viaje."
    },
    "slogan7": {
      "title": "Haz una pausa,",
      "highlight": "evita el agotamiento",
      "subtitle": "Respira entre dos periodos de recepción intercambiando tu alojamiento."
    },
    "slogan8": {
      "title": "El espíritu del viaje,",
      "highlight": "el verdadero",
      "subtitle": "Conoce a otros anfitriones y descubre nuevos lugares a bajo costo."
    },
    "slogan9": {
      "title": "100% Hecho en Francia",
      "highlight": "(Picardía)",
      "subtitle": "No es Silicon Valley, sino el Valle del Somme. Una plataforma artesanal, humana y orgullosa de sus raíces."
    }
  }
};
